import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ValidatorViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ValidatorViewPage extends Component<ValidatorViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.validator.view }}
                pages={{
                    entity: InferenceEntities.validator(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}